import { axiosService } from './axiosService';

const auth = () => axiosService.setAuth(true);

const unwrap = async (req: Promise<any>) => {
  try {
    const { data } = await req;
    return { ok: true, data: data?.data ?? data, raw: data };
  } catch (error: any) {
    const message =
      (error?.response?.data?.message) || error?.message || 'Request failed';
    return { ok: false, error: message };
  }
};

// Matches the backend Product enum. 'ALL' = no app filter (every app).
export type NotificationApp = 'ALL' | 'SUPER_PREP' | 'SUPER_COACH' | 'TEACHER_APP';

export interface SendPushPayload {
  title: string;
  body: string;
  target: 'broadcast' | 'user';
  app?: NotificationApp;
  mobile?: string;
  url?: string;
}

export const notificationService = {
  // Sends an admin-composed push via the user-service.
  // Returns { sent, target, app, recipients, devices } on success.
  sendPush: (payload: SendPushPayload) =>
    unwrap(auth().post('user/notification/push-broadcast', payload)),
};
